import { render, staticRenderFns } from "./SactinERP.vue?vue&type=template&id=29e3cad0&scoped=true&"
import script from "./SactinERP.vue?vue&type=script&lang=js&"
export * from "./SactinERP.vue?vue&type=script&lang=js&"
import style0 from "./SactinERP.vue?vue&type=style&index=0&id=29e3cad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3cad0",
  null
  
)

export default component.exports